<template>
  <div>
    <div class="main-wrap">
      <div class="checkin-wrap">
        <div class="checkin-content">
          <el-row>
            <el-col :span="24">
              <img src="@/assets/images/logo-white.png" alt>
            </el-col>
          </el-row>
          <el-row>
            <el-col :span="24">
              <h2>客户咨询登记表</h2>
            </el-col>
          </el-row>
          <!--表单部分 start-->
          <el-row v-if="checkinLock">
            <el-col :span="24">
              <div class="form-area">
                <el-form ref="formData" :model="formData" class="el-element-form">
                  <el-row>
                    <h3>意向国家</h3>
                    <el-col :span="24">
                      <el-form-item>
                        <el-checkbox-group v-model="formData.custom_hope_country">
                          <el-checkbox
                            v-for="item in intentionCountries"
                            :key="item.id"
                            :label="item.id"
                          >{{ item.value }}</el-checkbox>
                        </el-checkbox-group>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <h3>基本信息</h3>
                    <el-col :span="6">
                      <el-form-item>
                        <span class="el-span">姓名：</span>
                        <el-input
                          class="el-input"
                          placeholder="请输入..."
                          v-model="formData.custom_name"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item>
                        <span class="el-span">手机：</span>
                        <el-input class="el-input" placeholder="请输入..." v-model="formData.crm_tel"/>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item>
                        <span class="el-span">微信：</span>
                        <el-input
                          class="el-input"
                          placeholder="请输入..."
                          v-model="formData.crm_weixin"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item>
                        <span class="el-span">QQ：</span>
                        <el-input class="el-input" placeholder="请输入..." v-model="formData.crm_qq"/>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="6">
                      <el-form-item>
                        <span class="el-span">年龄：</span>
                        <el-input class="el-input" placeholder="请输入..." v-model="age"/>
                      </el-form-item>
                    </el-col>
                    <el-col :span="6">
                      <el-form-item>
                        <span class="el-span">性别：</span>
                        <jm-dict-select
                          class="jm-input135"
                          clearable
                          type="dataset"
                          v-model="formData.custom_sex"
                          dict-type="student"
                          name="genderTwo"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item>
                        <span class="el-span">学历：</span>
                        <jm-education-select v-model="formData.education" clearable/>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <h3>详细信息</h3>
                    <el-col :span="12">
                      <el-form-item>
                        <span class="el-span el-span-margin">毕业学校：</span>
                        <jm-Search
                          clearable
                          class="jm-input175"
                          v-model="formData"
                          get-value="custom_school"
                          :get-other-value="['custom_school_type']"
                          get-type="sh_name_cn"
                          :getother-type="['school_type']"
                          get-url="/index/api_base/searchGSchool"
                        />&emsp;
                        <el-radio v-model="formData.custom_school_type" :label="1">985</el-radio>
                        <el-radio v-model="formData.custom_school_type" :label="2">211</el-radio>
                        <el-radio v-model="formData.custom_school_type" :label="3">双非</el-radio>
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item>
                        <!--// <custom_graduation></custom_graduation>-->
                        <span class="el-span el-span-margin2">毕业时间：</span>
                        <el-date-picker
                          class="el-element-date"
                          v-model="formData.custom_graduation"
                          :editable="false"
                          type="year"
                          value-format="yyyy"
                          placeholder="选择日期"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="12">
                      <el-form-item>
                        <span class="el-span el-span-margin">所读专业：</span>
                        <jm-Search
                          clearable
                          class="el-input-large"
                          v-model="formData"
                          get-value="custom_major"
                          get-other-value="professional_ower"
                          get-type="value"
                          getother-type="pid"
                          get-list="value"
                          get-url="/index/api_base/serachGProfessional"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item>
                        <span class="el-span">其他国家拒签史：</span>
                        <el-select clearable v-model="formData.custom_refusal" placeholder="请选择">
                          <el-option label="无" :value="1">无</el-option>
                          <el-option label="有" :value="2">有</el-option>
                        </el-select>
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item>
                        <span class="el-span el-span-margin">工作经验：</span>
                        <el-input
                          class="el-input-large"
                          placeholder="请输入..."
                          v-model="jobExperience"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item>
                        <span class="el-span el-span-margin2">计划何时出国：</span>
                        <el-date-picker
                          v-model="formData.custom_year"
                          align="left"
                          value-format="yyyy"
                          :editable="false"
                          type="year"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="12">
                      <el-form-item class="el-span">
                        <span class="el-span el-span-margin">英语成绩：</span>
                        <span class="el-span-span">TOEFL:</span>
                        <el-input
                          placeholder="L"
                          v-model="formData._scores[23].ln_listen"
                          class="el-input-small"
                        />
                        <el-input
                          placeholder="R"
                          v-model="formData._scores[23].ln_read"
                          class="el-input-small"
                        />
                        <el-input
                          placeholder="W"
                          v-model="formData._scores[23].ln_write"
                          class="el-input-small"
                        />
                        <el-input
                          placeholder="S"
                          v-model="formData._scores[23].ln_say"
                          class="el-input-small"
                        />
                        <el-input
                          placeholder="总"
                          v-model="formData._scores[23].ln_all"
                          class="el-input-small"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item>
                        <span class="el-span-span">IELTS:</span>
                        <el-input
                          placeholder="L"
                          v-model="formData._scores[22].ln_listen"
                          class="el-input-small"
                        />
                        <el-input
                          placeholder="R"
                          v-model="formData._scores[22].ln_read"
                          class="el-input-small"
                        />
                        <el-input
                          placeholder="W"
                          v-model="formData._scores[22].ln_write"
                          class="el-input-small"
                        />
                        <el-input
                          placeholder="S"
                          v-model="formData._scores[22].ln_say"
                          class="el-input-small"
                        />
                        <el-input
                          placeholder="总"
                          v-model="formData._scores[22].ln_all"
                          class="el-input-small"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item>
                        <span class="el-span-score">TOEIC:</span>
                        <el-input
                          placeholder="L"
                          v-model="formData._scores[129].ln_listen"
                          class="el-input-small"
                        />
                        <el-input
                          placeholder="R"
                          v-model="formData._scores[129].ln_read"
                          class="el-input-small"
                        />
                        <el-input
                          placeholder="W"
                          v-model="formData._scores[129].ln_write"
                          class="el-input-small"
                        />
                        <el-input
                          placeholder="S"
                          v-model="formData._scores[129].ln_say"
                          class="el-input-small"
                        />
                        <el-input
                          placeholder="总"
                          v-model="formData._scores[129].ln_all"
                          class="el-input-small"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item class="select-special">
                        <span class="el-span-span">CET:</span>
                        <jm-dict-select
                          clearable
                          v-model="formData._scores[671].ln_level"
                          dict-type="exam_cet"
                          :filter="(item) => item.pid === 671"
                        />
                        <el-input
                          placeholder="总"
                          v-model="formData._scores[671].ln_all"
                          class="el-input-small"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>
                  <el-row>
                    <el-col :span="12">
                      <el-form-item class="el-score">
                        <span class="el-span-score">GRE:</span>
                        <el-input
                          placeholder="数"
                          v-model="formData._scores[25].ln_read"
                          class="el-input-small"
                        />
                        <el-input
                          placeholder="语"
                          v-model="formData._scores[25].ln_write"
                          class="el-input-small"
                        />
                        <el-input
                          placeholder="写"
                          v-model="formData._scores[25].ln_say"
                          class="el-input-small"
                        />
                        <el-input
                          placeholder="总"
                          v-model="formData._scores[25].ln_all"
                          class="el-input-small"
                        />
                      </el-form-item>
                    </el-col>
                    <el-col :span="12">
                      <el-form-item>
                        <span class="el-span-span">GMAT:</span>
                        <el-input
                          placeholder="写"
                          v-model="formData._scores[24].ln_listen"
                          class="el-input-small"
                        />
                        <el-input
                          placeholder="综"
                          v-model="formData._scores[24].ln_read"
                          class="el-input-small"
                        />
                        <el-input
                          placeholder="数"
                          v-model="formData._scores[24].ln_write"
                          class="el-input-small"
                        />
                        <el-input
                          placeholder="语"
                          v-model="formData._scores[24].ln_say"
                          class="el-input-small"
                        />
                        <el-input
                          placeholder="总"
                          v-model="formData._scores[24].ln_all"
                          class="el-input-small"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="24">
                      <el-form-item>
                        <span class="el-span">在校平均/GPA:</span>
                        <el-input
                          class="el-input-large"
                          placeholder="请输入..."
                          v-model="formData.custom_avg_score"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col :span="24">
                      <el-form-item>
                        <span class="el-span el-span-margin jm-fl">记录:</span>
                        <el-input
                          class="el-element-textarea jm-fl"
                          type="textarea"
                          v-model="formData.crm_memo"
                        />
                      </el-form-item>
                    </el-col>
                  </el-row>

                  <el-row>
                    <el-col>
                      <el-form-item>
                        <el-button type="primary" @click="saveForm" class="el-element-button">提交</el-button>
                        <el-button @click="resetForm" class="el-element-button">重置</el-button>
                      </el-form-item>
                    </el-col>
                  </el-row>
                </el-form>
              </div>
            </el-col>
          </el-row>
          <!--表单部分 end-->
        </div>
        <div v-if="!checkinLock" class="checkin-success-area">
          <h3>客户咨询登记表提交成功!</h3>
          <img src="@/assets/images/img-checkin-success.jpg" alt>
          <el-button @click="backIndex" class="btn-back" type="primary">{{ backNum }}秒后返回</el-button>
        </div>
        <div class="checkin-footer">
          <span>© 2010-2018 大连拓中教育科技股份有限公司</span>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import {
  jmSearch,
  jmDictSelect,
  jmEducationSelect,
  jmSchoolSearch
} from '@/components/tool';
import '@/assets/css/special.css';

export default {
  data() {
    return {
      timeLock: null,
      backNum: 3,
      checkinLock: true,
      age: '',
      custom_year: '',
      custom_graduation: '',
      jobExperience: '',
      intentionCountries: {},
      formData: {
        custom_hope_country: [], // 意向国家
        custom_name: '',
        crm_tel: '',
        crm_weixin: '',
        crm_qq: '',
        custom_sex: '',
        education: [],
        custom_education: '',
        custom_detail: '',
        custom_school: '',
        custom_school_type: '',
        custom_major: '',
        custom_refusal: '',
        custom_avg_score: '',
        crm_memo: '',
        _scores: {
          22: {
            ln_level: '',
            ln_say: '',
            ln_all: '',
            ln_read: '',
            ln_write: '',
            ln_listen: '',
            ln_type: '22'
          },
          23: {
            ln_level: '',
            ln_say: '',
            ln_all: '',
            ln_read: '',
            ln_write: '',
            ln_listen: '',
            ln_type: '23'
          },
          24: {
            ln_level: '',
            ln_say: '',
            ln_all: '',
            ln_read: '',
            ln_write: '',
            ln_listen: '',
            ln_type: '24'
          },
          129: {
            ln_level: '',
            ln_say: '',
            ln_all: '',
            ln_read: '',
            ln_write: '',
            ln_listen: '',
            ln_type: '129'
          },
          671: {
            ln_level: '',
            ln_all: '',
            ln_type: '671'
          },
          25: {
            ln_level: '',
            ln_say: '',
            ln_all: '',
            ln_read: '',
            ln_write: '',
            ln_type: '25'
          }
        }
      }
    };
  },
  computed: {},
  methods: {
    backIndex() {
      this.checkinLock = true;
      clearInterval(this.timeLock);
    },
    saveForm() {
      let student = JSON.stringify(this.formData);
      student = JSON.parse(student);
      if (this.age) {
        student.crm_memo = `${student.crm_memo} 年龄：${this.age}`;
      }
      if (this.jobExperience) {
        student.crm_memo = `${student.crm_memo} 工作经验：${
          this.jobExperience
        }`;
      }
      student.custom_education = this.formData.education[0];
      student.custom_detail = this.formData.education[1];
      this.$confirm('是否确认提交用户信息？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      })
        .then(() => {
          this.$http
            ._post({
              url: '/index/student/checkIn',
              data: student
            })
            .then(() => {
              clearInterval(this.timeLock);
              this.resetForm();
              this.$message.success('提交成功');
              this.checkinLock = false;
              this.backNum = 3;
              let timeLock = setInterval(() => {
                this.backNum--;
                if (this.backNum === 0) {
                  this.checkinLock = true;
                  this.resetForm(); // 提交后表单重置
                }
              }, 1000);
              this.timeLock = timeLock;
            });
        })
        .catch(() => {
          this.$message.warning('已取消提交');
        });
    },
    getCountry() {
      this.$http
        ._get({
          url: '/index/api_base/hopeCountry'
        })
        .then(({ data }) => {
          data.splice(4, 1);
          data.splice(5, 1);
          data.splice(13, 1);
          this.intentionCountries = data;
        });
    },
    resetForm() {
      this.intentionCountries = '';
      this.getCountry();
      this.age = '';
      this.custom_year = '';
      this.custom_graduation = '';
      this.jobExperience = '';
      this.formData = {
        custom_hope_country: [], // 意向国家
        custom_name: '',
        crm_tel: '',
        crm_weixin: '',
        crm_qq: '',
        custom_sex: '',
        education: '',
        custom_education: '',
        custom_detail: '',
        custom_school: '',
        custom_school_type: '',
        custom_major: '',
        custom_refusal: '',
        custom_avg_score: '',
        crm_memo: '',
        _scores: {
          22: {
            ln_level: '',
            ln_say: '',
            ln_all: '',
            ln_read: '',
            ln_write: '',
            ln_listen: '',
            ln_type: '22'
          },
          23: {
            ln_level: '',
            ln_say: '',
            ln_all: '',
            ln_read: '',
            ln_write: '',
            ln_listen: '',
            ln_type: '23'
          },
          24: {
            ln_level: '',
            ln_say: '',
            ln_all: '',
            ln_read: '',
            ln_write: '',
            ln_listen: '',
            ln_type: '24'
          },
          129: {
            ln_level: '',
            ln_say: '',
            ln_all: '',
            ln_read: '',
            ln_write: '',
            ln_listen: '',
            ln_type: '129'
          },
          671: {
            ln_level: '',
            ln_all: '',
            ln_type: '671'
          },
          25: {
            ln_level: '',
            ln_say: '',
            ln_all: '',
            ln_read: '',
            ln_write: '',
            ln_type: '25'
          }
        }
      };
    }
  },
  mounted() {
    this.getCountry();
  },
  components: {
    jmDictSelect,
    jmEducationSelect,
    jmSchoolSearch,
    jmSearch
  }
};
</script>
